import { Injectable } from '@angular/core';


@Injectable()
export class JwtService {

  getToken(): string {
    return sessionStorage.getItem('jwt_token_hachette_kne');
  }

  saveToken(token: string) {
    sessionStorage.setItem('jwt_token_hachette_kne', token);
  }

  destroyToken() {
    sessionStorage.removeItem('jwt_token_hachette_kne');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/jwt.service.ts